var stickyAccountHeader = function (position, accountHeader) {
	'use strict';

	let accountHeaderHeight = accountHeader.offsetHeight;

	if (position > accountHeaderHeight) {
		document.body.classList.add('t-sticky-account-header--is-active');
	} else if (!document.documentElement.classList.contains('x-mini-basket--is-open-ios')) {
		document.body.classList.remove('t-sticky-account-header--is-active');
	}
};

let animationTimeout = 0;
const accountHeader = document.querySelector('.js-account-header');

if (accountHeader) {
	stickyAccountHeader(window.pageYOffset || document.documentElement.scrollTop, accountHeader);

	window.addEventListener('scroll', function () {
		'use strict';

		if (animationTimeout) {
			window.cancelAnimationFrame(animationTimeout);
		}

		animationTimeout = window.requestAnimationFrame(function () {
			stickyAccountHeader(window.pageYOffset || document.documentElement.scrollTop, accountHeader);
		});
	}, false);
}
